import React, { useState, useEffect, useContext } from 'react';
import { Accordion, Icon, Dropdown, Menu, Loader, Image } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { SettingMenuContext } from './content';
import { getWaitingAreas, getMeetingRooms } from 'actions/organisation';
import { filterOptions, tableHeaderColour, filterShortTextOptions } from './content';
import HtmlToReact from 'html-to-react';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
let htmlToReactParser = new HtmlToReact.Parser(React);
// If entityAdminRights changes, filter value should be reset
// but cannot do it in useEffect as we should provide changes for that
// According to user's role, the filter bar could be a dropdown or just a Menu
// E.g Org admin should have a dropdown; service admin should have a menu of Waiing Areas
export function FilterDropdownMarkUp({
  entityAdminRights,
  useShortText,
  filterValue,
  filterOnChange,
  disabled = false,
}) {
  // This includes service admin & mr admin
  // if (isServiceAdminOnly(entityAdminRights)) {
  //   return (
  //     <Menu className="color-waiting-area-bg-highlight max-width">
  //       <Menu.Item id="entity-type-dropdown" style={{ marginTop: '-10px', width: '100%' }}>
  //         {useShortText ? filterShortTextOptions[1].text : filterOptions[1].text}
  //       </Menu.Item>
  //     </Menu>
  //   );
  // } else if (isMRAdminOnly(entityAdminRights)) {
  //   return (
  //     <Menu className="color-meeting-room-bg-highlight max-width">
  //       <Menu.Item id="entity-type-dropdown" style={{ marginTop: '-10px', width: '100%' }}>
  //         {useShortText ? filterShortTextOptions[2].text : filterOptions[2].text}
  //       </Menu.Item>
  //     </Menu>
  //   );
  // } else if (isServiceAndMRAdminOnly(entityAdminRights)) {
  //   let newFilterShortTextOptions = filterShortTextOptions.slice(1);
  //   let newFilterOptions = filterOptions.slice(1);
  //   return (
  //     <Dropdown
  //       id="entity-type-dropdown"
  //       className={'color-white ' + tableHeaderColour[filterValue].highlight}
  //       value={filterValue}
  //       onChange={filterOnChange}
  //       fluid
  //       selection
  //       options={useShortText ? newFilterShortTextOptions : newFilterOptions}
  //     />
  //   );
  // } else {
  return (
    <Dropdown
      id="entity-type-dropdown"
      className={'color-white color-organisational-unit-bg-highlight '}
      value={filterValue}
      onChange={filterOnChange}
      fluid
      selection
      options={useShortText ? filterShortTextOptions : filterOptions}
      disabled={disabled}
    />
  );
  //}
}

// When no matched result returned, this mark up will be shown
export function NoResultMarkUp({ isOnMobileOrTablet }) {
  return (
    <div className={'row flexible row-hoverable ' + (isOnMobileOrTablet ? 'pdlm pdrm' : '')}>
      <div className="column text-size-ml max-width center-text">{APP.LANGUAGE.ManageAllUsers.NoResults}</div>
      <div className="tablet only mobile only column pdtnull pdbnull max-width broder-bottom" />
    </div>
  );
}

// When filter is "Org Unit", open the org unit tree view, it has the first level tree:
// - Waiting Areas (xx of xx)
// - Meeting Rooms (xx of xx)
export function OrgUnit1stChildTreeView({
  index,
  orgUnit,
  isOnMobileOrTablet,
  filterValue,
  waListContent, // HTML of showing waiting areas
  mrListContent, // HTML of showing waiting areas
  waitingAreas, // Waiting areas' data of that orgunit
  meetingRooms, // Meeting rooms' data of that orgunit
}) {
  const [loadingWAData, setLoadingWAData] = useState(false);
  const [loadingMRData, setLoadingMRData] = useState(false);
  const dispatch = useDispatch();

  const viewAllWAsOfOrg = (orgUnit) => {
    setLoadingWAData(true);
    let cb = () => setLoadingWAData(false);
    dispatch(
      getWaitingAreas(
        {
          orgUnitNetworkId: orgUnit.networkId,
          pageNo: 1,
        },
        cb
      )
    );
  };

  const viewAllMRsOfOrg = (orgUnit) => {
    setLoadingMRData(true);
    let cb = () => setLoadingMRData(false);
    dispatch(
      getMeetingRooms(
        {
          orgUnitNetworkId: orgUnit.networkId,
          pageNo: 1,
        },
        cb
      )
    );
  };

  const waCountOnly = (
    <div className={(isOnMobileOrTablet ? 'pdlxs' : 'pdlxxs') + ' max-width inline-flex center-flex pdtm pdbm'}>
      {APP.LANGUAGE.EntityAdmin.WaitingArea + 's'}
      <span className="entity-count-org">&nbsp;{'(' + orgUnit.waitingAreaCount + ')'}</span>
      {loadingWAData ? <Loader active size="mini" inline="centered" className="mrls mrrs" /> : ''}
    </div>
  );

  const mrCountOnly = (
    <div className={(isOnMobileOrTablet ? 'pdlxs' : 'pdlxxs') + ' pdtm pdbm inline-flex center-flex'}>
      {APP.LANGUAGE.EntityAdmin.MeetingRoom + 's'}
      <span className="entity-count-org">&nbsp;{'(' + orgUnit.meetingRoomCount + ')'}</span>
      {loadingMRData ? <Loader active size="mini" inline="centered" className="mrls mrrs" /> : ''}
    </div>
  );

  const orgUnitChildPanels = [];
  // Add waiting area list
  if (orgUnit.waitingAreaCount > 0) {
    orgUnitChildPanels.push({
      key: 'wa-panel-' + orgUnit.networkId,
      title: {
        key: 'WA-title' + index,
        className:
          'inline-flex center-flex max-width broder-bottom bg-color-row-opened pdrnull pdtnull pdbnull ' +
          (isOnMobileOrTablet ? 'pdl-24' : 'pdlxl'),
        content: waCountOnly,
        onClick: (event, itemProps) => {
          if (
            !itemProps.active &&
            orgUnit.waCurrentActivePageNo === 1 &&
            (orgUnit.waitingAreas.length === orgUnit.waitingAreaCount || orgUnit.waitingAreas.length === 0)
          ) {
            // When panel is opened && only when no child entity matched, load waiting areas for first page initially
            viewAllWAsOfOrg(orgUnit);
          }
        },
      },
      content: {
        key: 'WA-content' + index,
        className: 'pdlnull pdrnull pdtnull pdbnull',
        content: waListContent,
      },
    });
  }
  // Add meeting room list
  if (orgUnit.meetingRoomCount > 0) {
    orgUnitChildPanels.push({
      key: 'mr-panel-' + orgUnit.networkId,
      title: {
        key: 'MR-title' + index,
        className:
          'inline-flex center-flex max-width broder-bottom bg-color-row-opened pdrnull pdtnull pdbnull ' +
          (isOnMobileOrTablet ? 'pdl-24' : 'pdlxl'),
        content: mrCountOnly,
        onClick: (event, itemProps) => {
          if (
            !itemProps.active &&
            orgUnit.mrCurrentActivePageNo === 1 &&
            (orgUnit.meetingRooms.length === orgUnit.meetingRoomCount || orgUnit.meetingRooms.length === 0)
          ) {
            // When panel is opened && only when no child entity matched, load waiting areas for first page initially
            viewAllMRsOfOrg(orgUnit);
          }
        },
      },
      content: {
        key: 'MR-content' + index,
        className: 'pdlnull pdrnull pdtnull pdbnull',
        content: mrListContent,
      },
    });
  }

  let defaultActiveIndex = [];
  if (filterValue === 2) {
    defaultActiveIndex = [0];
  } else if (filterValue === 3) {
    defaultActiveIndex = [1];
  } else {
    if (!!waitingAreas && waitingAreas.length > 0) {
      defaultActiveIndex.push(0);
    }
    if (!!meetingRooms && meetingRooms.length > 0) {
      defaultActiveIndex.push(1);
    }
  }

  // defaultActiveIndex means the index array of which tree is open / close by default
  // filterValue == 2 means filter is on WA, it should open all tree view by default, when first level tree view is only, defaultActiveIndex is 0
  // When filter is on ORG, if it has child entities matched search term (waitingAreas.length), it should open - set defaultActiveIndex to be 0;
  // defaultActiveIndex == -1 means no tree view is open
  return (
    <Accordion.Accordion
      key={index}
      defaultActiveIndex={defaultActiveIndex}
      className="mrtnull"
      exclusive={false}
      panels={orgUnitChildPanels}
    />
  );
}

// Org unit row markup
// When use does not have admin role of that org, e.g service admin, we don't show them a menu (hambergur bar)
export function OrgUnitTreeViewTitleWithoutMenu({
  index,
  onOrgUnitView,
  isOnMobileOrTablet,
  orgUnit,
  entityCountMarkup,
  noTreeView, // if org unit has 0 waiting areas and 0 meeting rooms, it does not have any tree views
}) {
  const { entityFilter, searchBar } = useContext(SettingMenuContext);
  const [filterValue, setFilterValue] = entityFilter;
  const [searchTermSubmitted, setSearchTermSubmitted] = searchBar;

  return (
    <React.Fragment>
      <div
        className={
          isOnMobileOrTablet && !noTreeView
            ? 'inline-flex flexible hand max-width'
            : 'inline-flex flexible center-flex hand max-width'
        }
        id="org-unit-row"
        key={index}
      >
        {noTreeView ? (
          <div
            className="tablet only computer only column left-text pdrnull inline-flex center-flex pdtm pdbm"
            style={{
              width: isOnMobileOrTablet ? '38px' : '42px',
            }}
          />
        ) : (
          ''
        )}
        <div
          className={
            'tablet only computer only column left-text pdrnull inline-flex center-flex pdtm pdbm ' +
            (isOnMobileOrTablet ? 'pdlnull' : '')
          }
          style={{
            width: '30px',
          }}
        >
          <div className="fl">
            <Icon name="sitemap" className="color-organisational-unit" />
          </div>
        </div>
        <div
          className={
            'tablet only computer only column left-column-fixed status-column left-text inline-flex center-flex pdtm pdbm ' +
            (isOnMobileOrTablet ? '' : 'pdlnull')
          }
          style={{
            width: onOrgUnitView
              ? noTreeView
                ? isOnMobileOrTablet
                  ? 'calc(100% - 68px)'
                  : 'calc(100% - 72px)'
                : 'calc(100% - 30px)'
              : noTreeView
              ? isOnMobileOrTablet
                ? 'calc(100% - 88px)'
                : 'calc(100% - 92px)'
              : 'calc(100% - 30px)',
          }}
        >
          <div className="pdrs">
            <div className="show-on-small-ress wrap-link">
              {filterValue === 1 && searchTermSubmitted ? tryParseHTML(orgUnit.name, getSearchString()) : orgUnit.name}
            </div>
            <div className="text-size-ms show-on-small-ress secondary-text">{entityCountMarkup}</div>
            <span className="hide-on-small-ress wrap-link">
              {filterValue === 1 && searchTermSubmitted ? tryParseHTML(orgUnit.name, getSearchString()) : orgUnit.name}
            </span>
            <span className="entity-count-org hide-on-small-ress">{entityCountMarkup}</span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

// // When use has admin role of that org, e.g org admin, we should show them a menu (hambergur bar)
export function OrgUnitTreeViewTitle({
  index,
  isOnMobileOrTablet,
  onOrgUnitView,
  orgUnit,
  filterValue,
  orgUnitHamBarOnClick,
  entityCountMarkup,
  orgMenuVisible,
  noTreeView, // if org unit has 0 waiting areas and 0 meeting rooms, it does not have any tree views
}) {
  const { orgSetting, entityFilter, searchBar } = useContext(SettingMenuContext);
  const [openOrgSettingMenu, setOpenOrgSettingMenu] = orgSetting;
  const [chevronPointsRight, setChevronPointsRight] = useState(false);
  const [searchTermSubmitted, setSearchTermSubmitted] = searchBar;

  useEffect(() => {
    setChevronPointsRight(openOrgSettingMenu);
  }, [openOrgSettingMenu]);

  return (
    <React.Fragment>
      <div
        key={index}
        className={
          isOnMobileOrTablet && !noTreeView
            ? 'inline-flex flexible hand max-width'
            : 'inline-flex flexible center-flex hand max-width'
        }
        id="org-unit-row"
      >
        {noTreeView ? (
          <div
            className="tablet only computer only column left-text pdrnull inline-flex center-flex pdtm pdbm"
            style={{
              width: isOnMobileOrTablet ? '38px' : '42px',
            }}
          />
        ) : (
          ''
        )}

        <div
          className={
            'tablet only computer only column left-column-fixed status-column left-text pdrnull inline-flex center-flex pdtm pdbm ' +
            (isOnMobileOrTablet ? 'pdlnull' : '')
          }
          style={{
            width: '30px',
          }}
        >
          <div className="fl">
            <Icon name="sitemap" className="color-organisational-unit" />
          </div>
        </div>
        <div
          className={
            'tablet only computer only column left-column-fixed status-column left-text inline-flex center-flex pdtm pdbm ' +
            (isOnMobileOrTablet ? '' : 'pdlnull')
          }
          style={{
            width: onOrgUnitView
              ? noTreeView
                ? isOnMobileOrTablet
                  ? 'calc(100% - 118px)'
                  : 'calc(100% - 122px)'
                : 'calc(100% - 80px)'
              : noTreeView
              ? isOnMobileOrTablet
                ? 'calc(100% - 88px)'
                : 'calc(100% - 92px)'
              : 'calc(100% - 30px)',
          }}
        >
          <div className="pdrs">
            <div className="show-on-small-ress wrap-link">
              {filterValue === 1 && searchTermSubmitted ? tryParseHTML(orgUnit.name, getSearchString()) : orgUnit.name}
            </div>
            <div className="text-size-ms secondary-text show-on-small-ress secondary-text">{entityCountMarkup}</div>
            <span className="hide-on-small-ress wrap-link">
              {filterValue === 1 && searchTermSubmitted ? tryParseHTML(orgUnit.name, getSearchString()) : orgUnit.name}
            </span>
            <span className="entity-count-org hide-on-small-ress">{entityCountMarkup}</span>
          </div>
        </div>
        <div
          className="tablet only computer only column pdrnull inline-flex center-with-flex pdts pdbs"
          style={{
            width: '50px',
          }}
          onClick={orgUnitHamBarOnClick}
        >
          {orgMenuVisible ? (
            isOnMobileOrTablet ? (
              <div>
                <Icon name="bars" className="color-organisational-unit" style={{ fontSize: '1.1rem' }} />
              </div>
            ) : (
              <div>
                <Icon
                  name="angle right"
                  className={'color-organisational-unit rotate ' + (chevronPointsRight ? 'left' : '')}
                  style={{ fontSize: '1.4rem' }}
                />
              </div>
            )
          ) : isOnMobileOrTablet ? (
            ''
          ) : (
            <div>
              <Icon name="angle right" className="color-white angle-hover" style={{ fontSize: '1.4rem' }} />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

// For each waiting area row
export function WaitingAreaRowMarkup({
  index,
  isOnMobileOrTablet,
  waitingArea,
  highlightWaitingAreas,
  waTextOnClick,
  waHamBarOnClick,
  waOnlyView,
}) {
  const { waSetting, entityFilter, searchBar } = useContext(SettingMenuContext);
  const [openWASettingMenu, setOpenWASettingMenu] = waSetting;
  const [filterValue, setFilterValue] = entityFilter;
  const [chevronPointsRight, setChevronPointsRight] = useState(false);
  const [searchTermSubmitted, setSearchTermSubmitted] = searchBar;

  useEffect(() => {
    setChevronPointsRight(openWASettingMenu);
  }, [openWASettingMenu]);

  return (
    <div
      key={index}
      className={
        (isOnMobileOrTablet ? 'row flexible hand pdlm pdrnull ' : 'row flexible hand ') +
        (highlightWaitingAreas.some((thisWA) => thisWA === waitingArea.id)
          ? 'wa-selected-row'
          : 'bg-color-row-opened hover-desktop')
      }
      id={'wa-row' + waitingArea.id}
    >
      <div
        className={
          'tablet only computer only column left-column-fixed status-column pdrnull inline-flex center-flex ' +
          (waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? 'wa-gc-icon-column ' : '') +
          (isOnMobileOrTablet ? 'pdlnull' : '')
        }
        style={{
          width: waOnlyView ? (isOnMobileOrTablet ? '36px' : '72px') : isOnMobileOrTablet ? '68px' : '102px',
          justifyContent: 'flex-end',
        }}
        onClick={waTextOnClick}
      >
        {waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
          <div className="wa-clock-icon">
            <Image src={APP.IMAGES.GCWaitingAreaIcon.default} className="icon" />
          </div>
        ) : (
          <div className="wa-clock-icon">
            <Icon name="clock" className="color-waiting-area-text" />
          </div>
        )}
      </div>
      <div
        className={
          'tablet only computer only column left-column-fixed status-column left-text inline-flex center-flex ' +
          (isOnMobileOrTablet ? '' : 'pdlnull')
        }
        style={{
          width: waOnlyView
            ? isOnMobileOrTablet
              ? 'calc(100% - 86px)'
              : 'calc(100% - 122px)'
            : isOnMobileOrTablet
            ? 'calc(100% - 118px)'
            : 'calc(100% - 152px)',
        }}
        onClick={waTextOnClick}
      >
        <div className="pdrs wrap-link standard-font-size">
          {filterValue === 1 && searchTermSubmitted
            ? tryParseHTML(waitingArea.name, getSearchString())
            : waitingArea.name}
          {waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
            <div className={'group-consultation-pill'}>
              <div className="span-like group-consultation-text" style={{ whiteSpace: 'nowrap' }}>
                {APP.LANGUAGE.EntityAdmin.GroupConsultation}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>

      <div
        className="tablet only computer only column left-text pdrnull inline-flex center-with-flex "
        style={{
          width: '50px',
        }}
        onClick={waHamBarOnClick}
      >
        {highlightWaitingAreas[0] === waitingArea.id ? (
          isOnMobileOrTablet ? (
            <div>
              <Icon name="bars" className="color-waiting-area-text" style={{ fontSize: '1.1rem' }} />
            </div>
          ) : (
            <div>
              <Icon
                name="angle right"
                className={'color-waiting-area-text rotate ' + (chevronPointsRight ? 'left' : '')}
                style={{ fontSize: '1.4rem' }}
              />
            </div>
          )
        ) : isOnMobileOrTablet ? (
          ''
        ) : (
          <div>
            <Icon name="angle right" className="color-row-opened angle-hover" style={{ fontSize: '1.4rem' }} />
          </div>
        )}
      </div>
    </div>
  );
}

// For each waiting area row
export function WaitingAreaRowMarkupWithoutMenu({ index, isOnMobileOrTablet, waitingArea, waOnlyView }) {
  const { entityFilter, searchBar } = useContext(SettingMenuContext);
  const [filterValue, setFilterValue] = entityFilter;
  const [searchTermSubmitted, setSearchTermSubmitted] = searchBar;

  return (
    <div
      key={index}
      className={
        isOnMobileOrTablet
          ? 'row flexible arrow pdlm pdrnull color-placeholder '
          : 'row flexible arrow color-placeholder '
      }
      id={'wa-row' + waitingArea.id}
      c
    >
      <div
        className={
          'tablet only computer only column left-column-fixed status-column pdrnull inline-flex center-flex ' +
          (waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? 'wa-gc-icon-column ' : '') +
          (isOnMobileOrTablet ? 'pdlnull' : '')
        }
        style={{
          width: waOnlyView ? (isOnMobileOrTablet ? '36px' : '72px') : isOnMobileOrTablet ? '68px' : '102px',
          justifyContent: 'flex-end',
        }}
      >
        {waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
          <div className="wa-clock-icon">
            <Image src={APP.IMAGES.GCWaitingAreaIcon.default} className="icon" />
          </div>
        ) : (
          <div className="wa-clock-icon">
            <Icon name="clock" className="color-waiting-area-text" />
          </div>
        )}
      </div>
      <div
        className={
          'tablet only computer only column left-column-fixed status-column left-text inline-flex center-flex ' +
          (isOnMobileOrTablet ? '' : 'pdlnull')
        }
        style={{
          width: waOnlyView
            ? isOnMobileOrTablet
              ? 'calc(100% - 86px)'
              : 'calc(100% - 122px)'
            : isOnMobileOrTablet
            ? 'calc(100% - 118px)'
            : 'calc(100% - 152px)',
        }}
      >
        <div className="pdrs wrap-link standard-font-size">
          {filterValue === 1 && searchTermSubmitted
            ? tryParseHTML(waitingArea.name, getSearchString())
            : waitingArea.name}
          {waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
            <div className={'group-consultation-pill'}>
              <div className="span-like group-consultation-text" style={{ whiteSpace: 'nowrap' }}>
                {APP.LANGUAGE.EntityAdmin.GroupConsultation}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div
        className="tablet only computer only column left-text pdrnull inline-flex center-with-flex "
        style={{
          width: '50px',
        }}
      />
    </div>
  );
}

// For each meeting room row
export function MeetingRoomRowMarkup({
  index,
  isOnMobileOrTablet,
  meetingRoom,
  highlightMeetingRooms,
  mrTextOnClick,
  mrHamBarOnClick,
  mrOnlyView,
}) {
  const { mrSetting, entityFilter, searchBar } = useContext(SettingMenuContext);
  const [filterValue, setFilterValue] = entityFilter;
  const [openMRSettingMenu, setOpenMRSettingMenu] = mrSetting;
  const [chevronPointsRight, setChevronPointsRight] = useState(false);
  const [searchTermSubmitted, setSearchTermSubmitted] = searchBar;

  useEffect(() => {
    setChevronPointsRight(openMRSettingMenu);
  }, [openMRSettingMenu]);

  return (
    <div
      key={index}
      className={
        (isOnMobileOrTablet ? 'row flexible hand pdlm pdrnull ' : 'row flexible hand ') +
        (highlightMeetingRooms.some((thisMR) => thisMR === meetingRoom.id)
          ? 'mr-selected-row'
          : 'bg-color-row-opened hover-desktop')
      }
      id={'wa-row' + meetingRoom.id}
    >
      <div
        className={
          'tablet only computer only column left-column-fixed status-column pdrnull inline-flex center-flex ' +
          (isOnMobileOrTablet ? 'pdlnull' : '')
        }
        style={{
          width: mrOnlyView ? (isOnMobileOrTablet ? '36px' : '72px') : isOnMobileOrTablet ? '68px' : '102px',
          justifyContent: 'flex-end',
        }}
        onClick={mrTextOnClick}
      >
        <div className="mr-group-icon">
          <Icon name="group" className="color-meeting-room" />
        </div>
      </div>
      <div
        className={
          'tablet only computer only column left-column-fixed status-column left-text inline-flex center-flex ' +
          (isOnMobileOrTablet ? '' : 'pdlnull')
        }
        style={{
          width: mrOnlyView
            ? isOnMobileOrTablet
              ? 'calc(100% - 86px)'
              : 'calc(100% - 122px)'
            : isOnMobileOrTablet
            ? 'calc(100% - 118px)'
            : 'calc(100% - 152px)',
        }}
        onClick={mrTextOnClick}
      >
        <div className="pdrs wrap-link standard-font-size">
          {filterValue === 1 && searchTermSubmitted
            ? tryParseHTML(meetingRoom.name, getSearchString())
            : meetingRoom.name}
        </div>
      </div>

      <div
        className="tablet only computer only column left-text pdrnull inline-flex center-with-flex "
        style={{
          width: '50px',
        }}
        onClick={mrHamBarOnClick}
      >
        {highlightMeetingRooms[0] === meetingRoom.id ? (
          isOnMobileOrTablet ? (
            <div>
              <Icon name="bars" className="color-meeting-room" style={{ fontSize: '1.1rem' }} />
            </div>
          ) : (
            <div>
              <Icon
                name="angle right"
                className={'color-meeting-room rotate ' + (chevronPointsRight ? 'left' : '')}
                style={{ fontSize: '1.4rem' }}
              />
            </div>
          )
        ) : isOnMobileOrTablet ? (
          ''
        ) : (
          <div>
            <Icon name="angle right" className="color-row-opened angle-hover" style={{ fontSize: '1.4rem' }} />
          </div>
        )}
      </div>
    </div>
  );
}

export function MeetingRoomRowMarkupWithoutMenu({ index, isOnMobileOrTablet, meetingRoom, mrOnlyView }) {
  const { entityFilter, searchBar } = useContext(SettingMenuContext);
  const [filterValue, setFilterValue] = entityFilter;
  const [searchTermSubmitted, setSearchTermSubmitted] = searchBar;

  return (
    <div
      key={index}
      className={
        isOnMobileOrTablet
          ? 'row flexible arrow pdlm pdrnull color-placeholder '
          : 'row flexible arrow color-placeholder '
      }
      id={'wa-row' + meetingRoom.id}
    >
      <div
        className={
          'tablet only computer only column left-column-fixed status-column pdrnull inline-flex center-flex ' +
          (isOnMobileOrTablet ? 'pdlnull' : '')
        }
        style={{
          width: mrOnlyView ? (isOnMobileOrTablet ? '36px' : '72px') : isOnMobileOrTablet ? '68px' : '102px',
          justifyContent: 'flex-end',
        }}
      >
        <div className="mr-group-icon">
          <Icon name="group" className="color-placeholder" />
        </div>
      </div>
      <div
        className={
          'tablet only computer only column left-column-fixed status-column left-text inline-flex center-flex ' +
          (isOnMobileOrTablet ? '' : 'pdlnull')
        }
        style={{
          width: mrOnlyView
            ? isOnMobileOrTablet
              ? 'calc(100% - 86px)'
              : 'calc(100% - 122px)'
            : isOnMobileOrTablet
            ? 'calc(100% - 118px)'
            : 'calc(100% - 152px)',
        }}
      >
        <div className="pdrs wrap-link standard-font-size">
          {filterValue === 1 && searchTermSubmitted
            ? tryParseHTML(meetingRoom.name, getSearchString())
            : meetingRoom.name}
        </div>
      </div>

      <div
        className="tablet only computer only column left-text pdrnull inline-flex center-with-flex "
        style={{
          width: '50px',
        }}
      />
    </div>
  );
}

// It will generate org unit row markup, according to if the tree can be expanded;
// It will return OrgUnitTreeViewTitle if user has admin permissions to see the hambergur bar;
// or return OrgUnitTreeViewTitleWithoutMenu if user cannot see the hambergur bar
// e.g org unit has 0 WAs and 0 MRs should not have tree view
export function OrgUnitTitleContent({
  viewOrgMenuCapability,
  orgUnit,
  filterValue,
  isOnMobileOrTablet,
  orgUnitHamBarOnClick,
  entityCountMarkup,
  highlightOrgUnits,
  noTreeView,
  isActive,
}) {
  if (!!viewOrgMenuCapability) {
    return (
      <OrgUnitTreeViewTitle
        index={orgUnit.networkId}
        filterValue={filterValue}
        onOrgUnitView={filterValue === 1}
        isOnMobileOrTablet={isOnMobileOrTablet}
        orgUnit={orgUnit}
        orgUnitHamBarOnClick={orgUnitHamBarOnClick}
        entityCountMarkup={entityCountMarkup}
        orgMenuVisible={viewOrgMenuCapability && highlightOrgUnits[0] === orgUnit.networkId}
        noTreeView={noTreeView}
      />
    );
  } else {
    return (
      <OrgUnitTreeViewTitleWithoutMenu
        index={orgUnit.networkId}
        onOrgUnitView={filterValue === 1}
        isOnMobileOrTablet={isOnMobileOrTablet}
        orgUnit={orgUnit}
        entityCountMarkup={entityCountMarkup}
        noTreeView={noTreeView}
      />
    );
  }
}

/* --------------------- helper functions --------------------- */
// To render (xx waiting areas, xx meeting rooms) on the right of org unit name in each org row
export function childEntityCountsMarkup(
  loadedWAArrayLength,
  loadedMRArrayLength,
  waitingAreaCount,
  meetingRoomCount,
  entityType
) {
  let entityCountMarkup = '';
  let waCountMarkup = '';
  let mrCountMarkup = '';

  const generateWACountMarkup = (waitingAreaCount) => {
    let string =
      waitingAreaCount != 0
        ? waitingAreaCount == 1
          ? `${waitingAreaCount} ${APP.LANGUAGE.EntityAdmin.WaitingArea}`
          : `${waitingAreaCount} ${APP.LANGUAGE.EntityAdmin.WaitingArea}s`
        : '';
    return string;
  };

  const generateMRCountMarkup = (meetingRoomCount) => {
    let string =
      meetingRoomCount != 0
        ? meetingRoomCount == 1
          ? `${meetingRoomCount} ${APP.LANGUAGE.EntityAdmin.MeetingRoom}`
          : `${meetingRoomCount} ${APP.LANGUAGE.EntityAdmin.MeetingRoom}s`
        : '';

    return string;
  };

  if (entityType === 'wa') {
    // When filter is 'WA', it only shows wa count
    if (waitingAreaCount != 0) {
      if (loadedWAArrayLength > 0 && loadedWAArrayLength < waitingAreaCount) {
        waCountMarkup = APP.LANGUAGE.EntityAdmin.CountOfTotal.replace('##count##', loadedWAArrayLength).replace(
          '##total##',
          waitingAreaCount + ' ' + APP.LANGUAGE.EntityAdmin.WaitingArea + (waitingAreaCount > 1 ? 's' : '')
        );
      } else {
        waCountMarkup = generateWACountMarkup(waitingAreaCount);
      }
      entityCountMarkup = ` (` + waCountMarkup + `)`;
    }
  } else if (entityType === 'mr') {
    // When filter is 'MR', it only shows mr count
    if (meetingRoomCount != 0) {
      if (loadedMRArrayLength > 0 && loadedMRArrayLength < meetingRoomCount) {
        mrCountMarkup = APP.LANGUAGE.EntityAdmin.CountOfTotal.replace('##count##', loadedMRArrayLength).replace(
          '##total##',
          meetingRoomCount + ' ' + APP.LANGUAGE.EntityAdmin.MeetingRoom + (meetingRoomCount > 1 ? 's' : '')
        );
      } else {
        mrCountMarkup = generateMRCountMarkup(meetingRoomCount);
      }
      entityCountMarkup = ` (` + mrCountMarkup + `)`;
    }
  } else {
    // When filter is 'org', it shows wa & mr count
    if (waitingAreaCount != 0 || meetingRoomCount != 0) {
      waCountMarkup = generateWACountMarkup(waitingAreaCount);
      mrCountMarkup = generateMRCountMarkup(meetingRoomCount);

      entityCountMarkup =
        ` (` +
        waCountMarkup +
        (waCountMarkup != '' && mrCountMarkup != '' ? `, ` + mrCountMarkup : mrCountMarkup) +
        `)`;
    }
  }
  return entityCountMarkup;
}

// Get current search string
// When changing string in the search bar, we don't getSearchString
// We only getSearchString when user click the search icon or press enter
// To reduce content component to be re-rendered performance issue whenever string is changed in the search bar
export function getSearchString() {
  let searchString =
    (document.getElementById('searchBarInputEntity') && document.getElementById('searchBarInputEntity').value.trim()) ||
    '';
  return searchString;
}

// Check org level capability
export function checkViewOrgMenuCapability(orgUnit) {
  let canSeeOrgMenu = false;
  if (orgUnit.permissions) {
    canSeeOrgMenu =
      (orgUnit.permissions.indexOf('EDIT') > -1 && orgUnit.permissions.indexOf('VIEW') > -1) ||
      orgUnit.permissions.indexOf('CREATE_WAITING_AREA') > -1 ||
      orgUnit.permissions.indexOf('CREATE_MEETING_ROOM') > -1 ||
      (orgUnit.permissions.indexOf(APP.LANGUAGE.Org_Permission.VIEW_ASSIGNED_TAGS) > -1 &&
        orgUnit.reportingTagsEnabled);
  }
  return canSeeOrgMenu;
}

export function checkViewWAMenuCapability(waitingArea) {
  let canSeeWAMenu = false;
  if (waitingArea.permissions) {
    canSeeWAMenu =
      (waitingArea.permissions.indexOf('EDIT') > -1 && waitingArea.permissions.indexOf('VIEW') > -1) ||
      waitingArea.permissions.indexOf('MANAGE_ACCESS') > -1 ||
      waitingArea.permissions.indexOf('MANAGE_MEMBER_ROLES') > -1 ||
      (waitingArea.permissions.indexOf(APP.LANGUAGE.Org_Permission.VIEW_ASSIGNED_TAGS) > -1 &&
        waitingArea.reportingTagsEnabled);
  }
  return canSeeWAMenu;
}

export function checkViewMRMenuCapability(meetingRoom) {
  let canSeeMRMenu = false;
  if (meetingRoom.permissions) {
    canSeeMRMenu =
      (meetingRoom.permissions.indexOf('EDIT') > -1 && meetingRoom.permissions.indexOf('VIEW') > -1) ||
      meetingRoom.permissions.indexOf('MANAGE_ACCESS') > -1 ||
      meetingRoom.permissions.indexOf('MANAGE_MEMBER_ROLES') > -1 ||
      (meetingRoom.permissions.indexOf(APP.LANGUAGE.Org_Permission.VIEW_ASSIGNED_TAGS) > -1 &&
        meetingRoom.reportingTagsEnabled);
  }
  return canSeeMRMenu;
}

export function isServiceAdminOnly(entityAdminRights) {
  return (
    entityAdminRights.isServiceAdmin &&
    !entityAdminRights.isAdmin &&
    !entityAdminRights.isOrgAdmin &&
    !entityAdminRights.isMeetingRoomAdmin
  );
}

export function isMRAdminOnly(entityAdminRights) {
  return (
    entityAdminRights.isMeetingRoomAdmin &&
    !entityAdminRights.isServiceAdmin &&
    !entityAdminRights.isAdmin &&
    !entityAdminRights.isOrgAdmin
  );
}

export function isServiceAndMRAdminOnly(entityAdminRights) {
  return (
    entityAdminRights.isMeetingRoomAdmin &&
    entityAdminRights.isServiceAdmin &&
    !entityAdminRights.isAdmin &&
    !entityAdminRights.isOrgAdmin
  );
}

export function getInitialFilterValueByRoles(entityAdminRights, previousPage, storedFilterValue) {
  // This includes service admin & mr admin
  // let newFilterValue =
  //   isServiceAdminOnly(entityAdminRights) || isServiceAndMRAdminOnly(entityAdminRights)
  //     ? 2
  //     : isMRAdminOnly(entityAdminRights)
  //       ? 3
  //       : 1;

  let newFilterValue = 1;
  if (previousPage && storedFilterValue) {
    if (
      previousPage === APP.LANGUAGE.OrganisationalUnitManageUsers.PageHeaderTitle ||
      previousPage === APP.LANGUAGE.WaitingAreaManageUsers.PageHeaderTitle ||
      previousPage === APP.LANGUAGE.WaitingAreaManageTags.PageHeaderTitle ||
      previousPage === APP.LANGUAGE.OrganisationalUnitManageTags.PageHeaderTitle
    ) {
      // When previous page is "Manage Users / Manage Tags"
      newFilterValue = storedFilterValue;
    }
  }
  return newFilterValue;
}

// Bold matched text in string
export function highlightMatchedText(rawString, searchString) {
  let search_regexp = new RegExp(searchString, 'gi');
  let output =
    searchString != '' ? rawString.replace(search_regexp, '<span class="highlight-text">$&</span>') : rawString;
  return output;
}

function tryParseHTML(orginalStr, matchedStr) {
  // Sometimes when str contains contaminated script, the parse will cause error
  try {
    let parsedStr = htmlToReactParser.parse(highlightMatchedText(orginalStr, matchedStr));
    return (
      <ErrorBoundary orginalStr={orginalStr}>
        <span>{parsedStr}</span>
      </ErrorBoundary>
    );
  } catch (err) {
    console.error(err.toString());
    return (
      <ErrorBoundary orginalStr={orginalStr}>
        <span>{orginalStr}</span>
      </ErrorBoundary>
    );
  }
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    console.log('error', error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <span>{this.props.orginalStr}</span>;
    }
    return this.props.children;
  }
}
